import { computed, inject, provide, type ComputedRef, type InjectionKey } from 'vue'

const StickyBoundsKey: InjectionKey<ComputedRef<HTMLElement | null>> = Symbol('StickyBoundsKey')

/**
 * Registers `el` as the nearest clamping ancestor for a StickyContainer using
 * `fix-to-bounds` anywhere beneath this point. Relays whatever bounds an
 * outer ancestor already provided when `el` is absent/null, so an
 * intermediate RenderSlot that isn't itself a bounds provider doesn't shadow
 * the real one further up — the nearest ACTUAL provider wins, not the
 * nearest RenderSlot.
 */
export function provideStickyBounds(el: ComputedRef<HTMLElement | null>) {
  const outer = inject(StickyBoundsKey, null)
  provide(
    StickyBoundsKey,
    computed(() => el.value ?? outer?.value ?? null),
  )
}

export function useStickyBoundsIfAvailable(): ComputedRef<HTMLElement | null> | null {
  return inject(StickyBoundsKey, null)
}
